import { render, staticRenderFns } from "./CImgHover.vue?vue&type=template&id=7f3215fa&"
import script from "./CImgHover.vue?vue&type=script&lang=ts&"
export * from "./CImgHover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports